import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
@Injectable({
  providedIn: 'root'
})
export class MobilesdevicesService {
  public url: string;

  constructor(
      private _http: HttpClient
  ) {
      this.url = GLOBAL.url;
  }

  Getphonecheckdata(id: string | number): Observable<any> {

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    const endpoint = `${this.url}/mobilesdevices/mobile/list/${id}`;


    return this._http
      .post(endpoint, null, { headers }) 
      .pipe(map(res => res));
  }

}
